
const initialState = {
    loading: false,
    payoutLanData: [],
    payoutHoldReasons:[],
    payoutRecoveryReasons:[],
    payoutLanChannelWise: [],
    pratnerdata:[],
    error: "",

}

const payoutLanDataReducer = (state = initialState, action) => {
    switch (action.type) {
        case "GET_PAYOUT_LANDATA_SUCCESS":
            return {
                ...state,
                payoutLanData: action.payload,
                loading: false,
            };

        case "GET_PAYOUT_LANDATA_FAILURE":
            return {
                ...state,
                error: action.payload,
                payoutLanData: [],
                loading: false,
            };
            
        case "GET_PAYOUT_HOLD_REASON_SUCCESS":
             return {
                ...state,
                payoutHoldReasons: action.payload,
                loading: false,
            };

        case "GET_PAYOUT_HOLD_REASON_FAILURE":
             return {
                ...state,
                error:action.payload,
                payoutHoldReasons: [],
                loading: false,
            };
        case "GET_PAYOUT_RECOVERY_REASON_SUCCESS":
             return {
                ...state,
                payoutRecoveryReasons: action.payload,
                loading: false,
            };

        case "GET_PAYOUT_RECOVERY_REASON_FAILURE":
             return {
                ...state,
                error:action.payload,
                payoutRecoveryReasons: [],
                loading: false,
            };
              case "GET_PAYOUT_LAN_CHANNELWISE_SUCCESS":
             return {
                ...state,
                payoutLanChannelWise: action.payload,
                loading: false,
            };

        case "GET_PAYOUT_LAN_CHANNELWISE_FAILURE":
             return {
                ...state,
                error:action.payload,
                payoutLanChannelWise: [],
                loading: false,
            };
        case "GET_PRINCING_PARTNERDATA_SUCCESS":
             return {
                ...state,
                pratnerdata: action.payload,
                loading: false,
            };
        case "GET_PRINCING_PARTNERDATA_FAILURE":
             return {
                ...state,
                error:action.payload,
                pratnerdata: [],
                loading: false,
            };
        default:
            return state;
    }
};

export default payoutLanDataReducer;